(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/assets/javascripts/views/wager.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/assets/javascripts/views/wager.js');


'use strict';

svs.numbergames.prolongation.views.Wager = Marionette.View.extend({
  timeline: gsap.timeline(),
  isLoading: false,
  className() {
    let className = 'prolongation-wager';
    if (this.model.get('isExamined')) {
      if (this.model.get('winAmount')) {
        className += ' prolongation-wager-win';
      } else {
        className += ' prolongation-wager-nowin';
      }
    } else {
      className += ' prolongation-wager-unexamined';
    }
    return className;
  },
  regions: {
    betsRegion: '.prolongation-bets-region'
  },
  childViewEventPrefix: false,
  childViewTriggers: {
    detailsOpened: 'childview:detailsOpened',
    detailsClosed: 'childview:detailsClosed'
  },
  ui: {
    wagerContent: '.js-prolongation-wager-content',
    iconArrow: '.js-prolongation-wager-arrow-icon',
    iconLoading: '.js-prolongation-wager-loading-icon',
    showWagerBtn: '.js-show-wager-btn',
    prolongWagerBtn: '.js-prolong-wager-btn'
  },
  triggers: {
    'click @ui.wagerContent': 'wagerClicked'
  },
  modelEvents: {
    'change:isProlonged': 'render'
  },
  template(data) {
    return svs.numbergames.prolongation.templates.wager(data);
  },
  templateContext() {
    return {
      showRowsInside: svs.core.detect.breakpoint.equals('xs')
    };
  },
  onDomRefresh() {
    gsap.set(this.ui.iconLoading, {
      scale: 0,
      autoAlpha: 0
    });
    new svs.ui.RippleEffect(this.getUI('showWagerBtn'), () => {
      this.triggerMethod('showWager', this);
    });
    new svs.ui.RippleEffect(this.getUI('prolongWagerBtn'), () => {
      this.triggerMethod('prolongWager', this);
    });
  },
  onShowWager() {
    svs.numbergames.prolongation.logger.debug('views.Wager Show wager details.');
    location.href = svs.core.urlMapping.get("".concat(this.model.get('productId').toLowerCase(), "_BetDetail")).replace(':wagerId', this.model.get('wagerId')).replace(':currentDrawNumber', this.model.get('currentDrawNumber'));
  },
  onWagerClicked() {
    if (this.isLoading) return;
    if (this.getRegion('betsRegion').hasView()) {
      this.triggerMethod('hideDetails', this);
    } else {
      this.triggerMethod('showDetails', this);
    }
  },
  onShowDetails() {
    this.isLoading = true;
    this.timeline.to(this.ui.iconArrow, {
      duration: 0.2,
      scale: 0,
      autoAlpha: 0,
      rotation: 0
    }).to(this.ui.iconLoading, {
      duration: 0.2,
      scale: 1,
      autoAlpha: 1
    }).to(this.ui.iconLoading, {
      duration: 20,
      rotation: 7200,
      repeat: -1,
      ease: 'none'
    });
  },
  onOpenDetails() {
    const scrollTo = this.$el.offset().top - (svs.core.detect.dimensions.offsetTop + 6);
    this.timeline.to($('html,body'), {
      duration: 0.3,
      scrollTop: scrollTo
    });
    this.showChildView('betsRegion', new svs.numbergames.prolongation.views.Bets({
      model: this.model
    }));
  },
  onChildviewDetailsOpened() {
    this.isLoading = false;
    this.timeline.progress(1);
    gsap.to(this.ui.iconLoading, {
      duration: 0.3,
      scale: 0,
      autoAlpha: 0,
      rotation: 0
    });
    gsap.to(this.ui.iconArrow, {
      duration: 0.2,
      scale: 1,
      autoAlpha: 1,
      rotation: 180
    });
  },
  onHideDetails() {
    this.isLoading = true;
    this.getRegion('betsRegion').reset();
  },
  onChildviewDetailsClosed() {
    this.isLoading = false;
    this.timeline.kill();
    gsap.to(this.ui.iconArrow, {
      duration: 0.2,
      scale: 1,
      autoAlpha: 1,
      rotation: 0
    });
  }
});

 })(window);